import NikeScan from './NikeScan'

export default NikeScan